import script from "./CertificationShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationShow.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__